import React, { useState, useEffect } from "react";
import {
  TextField,
  Button,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Box,
  Typography,
} from "@mui/material";
import axiosInstance from "../../api/axiosInstance";
import { xorDecrypt } from "../../encrypt";

const Index = () => {
  const [keywordName, setKeywordName] = useState("");
  const [keywordValues, setKeywordValues] = useState("");
  const [keywords, setKeywords] = useState([]);
  const [selectedKeyword, setSelectedKeyword] = useState("");
  const [values, setValues] = useState([]);
  const [view, setView] = useState("add"); // State to manage the current view

  const token = xorDecrypt(localStorage.getItem("ABAtoken"));
  //console.log("Decrypted token:", token); // Log the decrypted token

  useEffect(() => {
    // Fetch all keywords for the dropdown
    axiosInstance
      .post(
        "/api/abanotes/getallnoteKeywords",
        {},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => setKeywords(response.data))
      .catch((error) => console.error("Error fetching keywords:", error));
  }, [token]);

  const handleAddKeyword = () => {
    // Add a new keyword
    axiosInstance
      .post(
        "/api/abanotes/addnotekeyword",
        { keyword: keywordName, keywordValues: keywordValues.split(",") },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((response) => {
        setKeywords([...keywords, response.data]);
        setKeywordName("");
        setKeywordValues("");
      })
      .catch((error) => console.error("Error adding keyword:", error));
  };

  const handleKeywordChange = (event) => {
    setSelectedKeyword(event.target.value);
    // Fetch values based on the selected keyword
    axiosInstance
      .post(
        "/api/abanotes/getnotekeyword",
        { keyword: event.target.value },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((response) => setValues(response.data))
      .catch((error) => console.error("Error fetching values:", error));
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <Box sx={{ width: "50%" }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
          <Button variant="contained" onClick={() => setView("add")}>
            Add Note Keywords
          </Button>
          <Button variant="contained" onClick={() => setView("view")}>
            View Note Keywords
          </Button>
        </Box>

        {view === "add" && (
          <>
            <Typography variant="h4" gutterBottom>
              Add Note Keyword
            </Typography>
            <FormControl fullWidth sx={{ mb: 2 }}>
              <TextField
                label="Keyword Name"
                value={keywordName}
                onChange={(e) => setKeywordName(e.target.value)}
                sx={{ mb: 2 }}
              />
              <TextField
                label="Keyword Values (comma separated)"
                value={keywordValues}
                onChange={(e) => setKeywordValues(e.target.value)}
                sx={{ mb: 2 }}
              />
              <Button variant="contained" onClick={handleAddKeyword}>
                Add Keyword
              </Button>
            </FormControl>
          </>
        )}

        {view === "view" && (
          <>
            <Typography variant="h4" gutterBottom>
              Select Keyword
            </Typography>
            <FormControl fullWidth sx={{ mb: 2 }}>
              <InputLabel>Keyword</InputLabel>
              <Select value={selectedKeyword} onChange={handleKeywordChange}>
                {keywords.map((keyword) => (
                  <MenuItem key={keyword.id} value={keyword.name}>
                    {keyword.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <Typography variant="h4" gutterBottom>
              Keyword Values
            </Typography>
            <Box>
              {values.map((value, index) => (
                <Typography key={index}>{value}</Typography>
              ))}
            </Box>
          </>
        )}
      </Box>
    </Box>
  );
};

export default Index;
